var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.156,
    height: 27.91,
    viewBox: "0 0 27.156 27.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M175.774,877.983a9.524,9.524,0,0,0,0-2.721l2.952-2.31a.7.7,0,0,0,.167-.893l-2.791-4.835a.69.69,0,0,0-.851-.3l-3.475,1.4a10.591,10.591,0,0,0-2.358-1.375l-.523-3.7a.718.718,0,0,0-.7-.586h-5.582a.7.7,0,0,0-.691.586l-.523,3.7a10.326,10.326,0,0,0-2.358,1.375l-3.475-1.4a.7.7,0,0,0-.851.3l-2.791,4.835a.7.7,0,0,0,.167.893l2.945,2.31a9.526,9.526,0,0,0,0,2.721l-2.945,2.31a.7.7,0,0,0-.167.893l2.791,4.835a.69.69,0,0,0,.851.3l3.475-1.4a10.591,10.591,0,0,0,2.358,1.375l.523,3.7a.7.7,0,0,0,.691.586H168.2a.7.7,0,0,0,.691-.586l.523-3.7a10.325,10.325,0,0,0,2.358-1.375l3.475,1.4a.7.7,0,0,0,.851-.3l2.791-4.835a.7.7,0,0,0-.167-.893Zm-10.369,3.524a4.884,4.884,0,1,1,4.884-4.884A4.881,4.881,0,0,1,165.405,881.506Z",
    transform: "translate(-151.831 -862.667)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.430ec98e78d2a34997fd082f1ba4e0f2.svg";
export { ForwardRef as ReactComponent };